import { ComponentType, type IConfig } from '../../types';
import { config as FilesUploadConfig } from '../files-upload/config';

export const config: IConfig = {
  component: ComponentType.FormFilesUpload,
  configGroups: [...FilesUploadConfig.configGroups],
};
